import merge from 'lodash.merge';
import aspect from './aspect';
export default (function (theme) {
  return merge(theme, aspect(theme), {
    aspectRatio: 4 / 3
  });
});